import React, { memo } from "react";
// import css from "./index.less";

export default memo(
  ({
    data,
    getText,
  }: {
    data: IMultiElementCombineMsg.INoteElem;
    getText: (text: IMultiElementCombineMsg.IText) => string;
  }) => {
    const {
      text_color,
      text_alignment,
      title,
      background_color,
      bottom_padding,
      top_padding,
      left_padding,
      right_padding,
    } = data;

    let style: IMultiElementCombineMsg.INoteStyle = {};
    text_color && (style.color = `#${text_color}`);
    // text_alignment 对齐方式 0:左 1:居中 2:右
    const textAlign = ["left", "center", "right"];
    text_alignment !== undefined &&
      (style.textAlign = textAlign[
        text_alignment
      ] as IMultiElementCombineMsg.textAlignment);

    // 默认采用原来的配置，有下发采用下发的配置
    background_color && (style.backgroundColor = `#${background_color}`);
    bottom_padding && (style.paddingBottom = `${bottom_padding}px`);
    top_padding && (style.paddingTop = `${top_padding}px`);
    left_padding && (style.paddingLeft = `${left_padding}px`);
    right_padding && (style.paddingRight = `${right_padding}px`);

    return (
      <span className={`sscard-noteBox`} style={style}>
        {getText(title)}
      </span>
    );
  }
);
